import parse from "html-react-parser";
import { Link } from "react-router";
import { classNames } from "@ct-react/core";
import { DataProps } from "../../tools/components";
import { Wrapper } from "../layout/wrapper";
import "./panel.scss";

type Props = {
  title?: string;
  content: any[];
}
const Panel = ({ className, data }: DataProps<Props>) => {

  const gridClasses = classNames("panel-grid", className);

  return (
    <Wrapper.Centered className="content">
      {!!data.title && <h2>{data.title}</h2>}
      <div className={gridClasses}>
        {data.content.map((item: any, index: number) => {
          const content = (
            <>
              {!!item["panel-image"] &&
                <img className="icon" src={item["panel-image"].originalUrl} alt={item["panel-name"] || ""} />
              }
              {!!item["panel-name"] &&
                <h3>{item["panel-name"]}</h3>
              }
              <div className="richtext">{parse(item["section-detail"])}</div>
            </>);
          return !!item["panel-nav"]
            ? <Link key={index} className="grid-item" to={item["panel-nav"]}>{content}</Link>
            : <div key={index} className="grid-item">{content}</div>
        })}
      </div>
    </Wrapper.Centered>);

};

export default Panel;
